export const createPaginatedCanonicalUrl = (originalCanonical) => (page) => {
  try {
    const pageCanonical = new URL(originalCanonical);
    const searchParams = new URLSearchParams(pageCanonical.search);
    if (page && page > 1) searchParams.set('page', page);
    pageCanonical.search = searchParams.toString();
    return pageCanonical.toString();
  } catch (e) {
    console.error(e);
    console.error('Parameters passed to createPaginatedCanonicalUrl: ', { originalCanonical, page });
    return originalCanonical;
  }
};
